"use strict";
/** @jsxRuntime classic */
/** @jsx jsx */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
var react_i18next_1 = require("react-i18next");
var theme_ui_1 = require("theme-ui");
var __1 = require("../../../");
var JagexLogo_1 = require("../../atoms/JagexLogo/JagexLogo");
var k1_art_jpg_1 = __importDefault(require("../../styles/Images/assets/k1-art.jpg"));
var DEFAULT_COPYRIGHT_TEXT_START = "Copyright © 1999 -";
var DEFAULT_COPYRIGHT_TEXT_END = "Jagex Ltd. 220 Science Park, Cambridge, CB4 0WA, UK";
var Footer = function () {
    var t = react_i18next_1.useTranslation("jds").t;
    return (theme_ui_1.jsx(theme_ui_1.Flex, { sx: {
            flexDirection: ["column", "column", "column", "column", "row"],
            justifyContent: [null, null, null, null, "space-between"],
            alignItems: ["center", "center", "center", "center", "stretch"],
            borderTop: "1px solid rgba(255, 255, 255, .06)",
            padding: ["53px 40px 40px", "53px 40px 40px", "53px 55px 55px", "53px 130px 130px", "53px 100px 150px", "53px 250px 150px"],
            position: "relative",
            "::after": {
                content: "''",
                position: "absolute",
                top: "-300px",
                right: 0,
                left: 0,
                bottom: 0,
                backgroundImage: "linear-gradient(" + __1.theme.colors.offBlack + " 10%, transparent), url(" + k1_art_jpg_1.default + ")",
                backgroundSize: "cover",
                backgroundPosition: "center bottom",
                zIndex: -1,
                opacity: 0.05,
            },
        } },
        theme_ui_1.jsx(theme_ui_1.Flex, { sx: {
                letterSpacing: __1.theme.letterSpacing.copyright,
                flexDirection: "column",
                fontSize: __1.theme.fontSizes[1],
                order: [3, 3, 3, 3, 1],
                textAlign: ["center", "center", "center", "center", "left"],
                flexBasis: "40%"
            } },
            theme_ui_1.jsx(theme_ui_1.Text, { as: "p", variant: "text.p", sx: {
                    maxWidth: ["unset", "unset", "unset", "unset", "425px"]
                } },
                t("footer:legal:copyrightStart", DEFAULT_COPYRIGHT_TEXT_START),
                " ",
                new Date().getFullYear(),
                " ",
                t("footer:legal:copyrightEnd", DEFAULT_COPYRIGHT_TEXT_END)),
            theme_ui_1.jsx(__1.JagexSocials, null)),
        theme_ui_1.jsx(theme_ui_1.Flex, { sx: { order: [1, 1, 1, 1, 2], alignItems: "flex-start", marginBottom: [30, 30, 30, 30, null] } },
            theme_ui_1.jsx(JagexLogo_1.JagexLogo, { iconColor: __1.theme.colors.white, hideName: true, width: 41 })),
        theme_ui_1.jsx(theme_ui_1.Flex, { sx: { order: [2, 2, 2, 2, 3], flexDirection: "column", maxWidth: "600px", flexBasis: "40%" } },
            theme_ui_1.jsx(__1.CompanyMainLinks, null),
            theme_ui_1.jsx(__1.CompanySubLinks, null))));
};
exports.Footer = Footer;
